import React from 'react';
import './Policy.css';

const PrivacyPolicy = () => {
  return (
    <div className="policy">
      <h1 className="policy-heading">Privacy Policy</h1>

      <h2 className="policy-subheading">1. Introduction</h2>
      <p className="policy-text">
        Welcome to Wert's Privacy Policy. At Wert, we are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy explains how we collect, use, and disclose your personal information when you use our website and services. By accessing and using our website, you consent to the practices described in this Privacy Policy.
      </p>

      <h2 className="policy-subheading">2. Information We Collect</h2>
      <p className="policy-text">
        We may collect personal information that you voluntarily provide to us, such as your name, email address, and contact details when you fill out forms on our website or communicate with us. We also collect certain non-personal information automatically, including your IP address, browser type, and device information.
      </p>

      <h2 className="policy-subheading">3. How We Use Your Information</h2>
      <p className="policy-text">
        We use the information we collect to provide and improve our services, respond to your inquiries, and communicate with you about our products and promotions. We may also use your information to analyze trends, track user engagement, and gather demographic information for internal purposes.
      </p>

      <h2 className="policy-subheading">4. Disclosure of Your Information</h2>
      <p className="policy-text">
        We do not sell, trade, or otherwise transfer your personal information to third parties without your consent. However, we may share your information with trusted third-party service providers who assist us in operating our website and providing our services. We may also disclose your information when required by law or to protect our rights, safety, or property.
      </p>

      <h2 className="policy-subheading">5. Data Security</h2>
      <p className="policy-text">
        We implement reasonable security measures to protect your personal information from unauthorized access and use. However, no method of transmission over the internet or electronic storage is completely secure, and we cannot guarantee the absolute security of your information.
      </p>

      <h2 className="policy-subheading">6. Your Choices</h2>
      <p className="policy-text">
        You have the right to review, update, and correct your personal information by contacting us. You may also opt-out of receiving marketing communications from us at any time by following the unsubscribe instructions included in our emails.
      </p>

      <h2 className="policy-subheading">7. Changes to Privacy Policy</h2>
      <p className="policy-text">
        We may update this Privacy Policy from time to time to reflect changes in our practices or for other operational, legal, or regulatory reasons. We will notify you of any material changes by posting the updated Privacy Policy on our website.
      </p>

      <h2 className="policy-subheading">8. Contact Us</h2>
      <p className="policy-text">
        If you have any questions or concerns about our Privacy Policy, please contact us at info@wertdigital.online.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
